export default __webpack_public_path__ + "static/media/image-homepage-profile.a9650530.jpg";